import Utilities from "@/common/utilities";

export default class ReportEndOfShiftModel {
    cashier: string | undefined;
    start: number | undefined;
    end: number | undefined;
    description: string | undefined;
    price: number | undefined;
    quantity: number | undefined;


    get priceDisplay(): string {
        return Utilities.toCurrency(this.price!);
    }

    get totalDisplay(): string {
        return Utilities.toCurrency(this.price! * this.quantity!);
    }

    static from(json: string): ReportEndOfShiftModel {
        let model = Object.assign(new ReportEndOfShiftModel(), json);
                
        return model;
    }

  }
  